module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "article-body"
  }, [_c('h1', {
    staticClass: "article-title"
  }, [_vm._v("The Story")]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n            I was really trying to avoid downloading the data from Socrata, organizing it, and creating my own API. Everything up to this point was built in javascript and pulling data directly from data.seattle.gov. But there was no way around it. So, I started building my own back end.\n          ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', [_vm._v("\n            Now that the data was organized nicely in my database, I could create new API endpoints pretty easily. I could also now mash up the Seattle Collisions data provided by data.seattle.gov with other data. For instance, the cost and neighborhood data were not part of the data set provided by data.seattle.gov. Now I have a foundation for adding new features. Woot!\n          ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', [_vm._v("\n            First, I need to get a job. After that, I would like to continue working on this project. I already have a "), _c('router-link', {
    attrs: {
      "to": {
        name: 'toDo'
      }
    }
  }, [_vm._v("to do list")]), _vm._v(". If you have suggestions, comments, feedback, or want to hire me =) drop me a line at "), _c('a', {
    attrs: {
      "href": "mailto:hello@timganter.io"
    }
  }, [_vm._v("hello@timganter.io")]), _vm._v(".\n          ")], 1), _vm._v(" "), _vm._m(10)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Hi! My name is "), _c('a', {
    attrs: {
      "href": "//timganter.io"
    }
  }, [_vm._v("Tim Ganter")]), _vm._v(" and I make websites.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//timganter.io"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/tim.jpg",
      "alt": "Tim Ganter"
    }
  })]), _vm._v(" Around fall 2016 I decided to wind down my consulting business "), _c('a', {
    attrs: {
      "href": "//www.studiotenfour.com"
    }
  }, [_vm._v("Studio Ten Four")]), _vm._v(" after 8 years and go back to a full-time salaried position. So, began my job search. "), _c('a', {
    attrs: {
      "href": "//studiotenfour.com/static/TimGanterResume.pdf"
    }
  }, [_vm._v("Resume here")]), _vm._v(". I decided to focus on becoming a better javascript developer and chose to do that within the context of data visualization. I started looking for open data to practice with and wanted to create something that would be useful to someone.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "//seattlegreenways.org"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/sng_logo.jpg",
      "alt": "Seattle Neighborhood Greenways Logo"
    }
  })]), _vm._v(" My co-working space "), _c('a', {
    attrs: {
      "href": "//impacthubseattle.com"
    }
  }, [_vm._v("Impact Hub Seattle")]), _vm._v(" hosts a members lunch every Thursday where announcements are often made by staff and other members. One day, "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/gordonpadelford"
    }
  }, [_vm._v("Gordon Padelford")]), _vm._v(" stood up to introduce himself and his organization "), _c('a', {
    attrs: {
      "href": "//seattlegreenways.org"
    }
  }, [_vm._v("Seattle Neighborhood Greenways")]), _vm._v(". I thought, \"Hey I bet they have some data that could be visualized\". So, I went up to Gordon after the member lunch and asked him. He introduced me to the Executive Director of Seattle Neighborhood Greenways, "), _c('a', {
    attrs: {
      "href": "//www.linkedin.com/in/cathytuttle"
    }
  }, [_vm._v("Cathy Tuttle")]), _vm._v(" and we all chatted a bit in their office at The Hub. They pointed me at the "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov/Transportation/SDOT-Collisions/v7k9-7dn4"
    }
  }, [_vm._v("Seattle Collisions data")]), _vm._v(" on "), _c('a', {
    attrs: {
      "href": "//data.seattle.gov"
    }
  }, [_vm._v("data.seattle.gov")]), _vm._v(". I started looking at the data and chipping away at creating something.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v("Proof of concept 1")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            The first thing I did was to see if I could simply display collisions on a map. I started reading up on the API for the Seattle Collisions data hosted by "), _c('a', {
    attrs: {
      "href": "//socrata.com"
    }
  }, [_vm._v("Socrata")]), _vm._v(" and researching what javascript libraries I might need. After a few hours I had "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/proto/1"
    }
  }, [_vm._v("a rough proof of concept")]), _vm._v(" of collisions working. I showed this to Cathy & Gordon and they said \"neat!\". Then the questions started coming. \"Can you show collisions by date?\", \"Can you show collisions in an area?\", \"How hard would it be to total up cost for collisions by severity if I gave you numbers?\". Sure! Let me see what I can do.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "p2"
    }
  }), _vm._v("Proof of concept 2")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A couple weeks went by. Work got busy. Trump got elected. Then I had a "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/proto/2"
    }
  }, [_vm._v("second proof of concept")]), _vm._v(". More useful than the first version but still not very useful. I wanted to make it better. However, I thought this should be enough to demonstrate my technical competency to employers. I started applying for jobs and while it definitely helped get some attention, turns out it wasn't quite enough to land the job I wanted. \n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "v1"
    }
  }), _vm._v("Version 1")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A few more weeks went by. Work was still busy. Trump got inaugurated. I started "), _c('a', {
    attrs: {
      "href": "//fortyfive.io"
    }
  }, [_vm._v("another side project")]), _vm._v(" out of frustration. Then I had a rough version of what is now the "), _c('a', {
    attrs: {
      "href": "//seattlecollisions.timganter.io/collisions"
    }
  }, [_vm._v("collisions page")]), _vm._v(". I showed this to Cathy & Gordon and they said \"Wow!\". There we go. That's the reaction I was looking for! =) I showed it around to some friends and got the same \"Wow!\". At this point I felt I was building something that could be really useful to folks interested in this data. Even if it didn't get me a job, at least people would be using it.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "id": "what"
    }
  }), _vm._v("What's next?")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Thanks for reading!"), _c('br'), _vm._v("\n            -Tim\n          ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a2cfa8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about/Story.vue
// module id = 435
// module chunks = 1